import React, { useState } from 'react';
import AnimatedHaloButton from '../AnimatedHaloButton';
import PolarisIcon from '../PolarisIcon';
import { IngestFile } from '@/redux/slices/slice_types';
import SigniantUpload from '@/components/FileManager/SigniantUpload';

interface IngestAwaitingFileButtonProps {
  ingestRecord: IngestFile;
}

const IngestAwaitingFileButton = ({ ingestRecord }: IngestAwaitingFileButtonProps) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    setOpen(!open);
  };

  return (
    <div>
      <AnimatedHaloButton variant="outlined" color="primary" startIcon={<PolarisIcon icon="upload" height={18} />} onClick={handleClick}>
        Awaiting File
      </AnimatedHaloButton>
      <SigniantUpload open={open} file={ingestRecord} onClose={handleClick} />
    </div>
  );
};

export default IngestAwaitingFileButton;
